import "es6-promise/auto";
import Vue from "vue";

// Vue packages
import Vuex from "vuex";
import VueMq from "vue-mq";
import VueParticles from "vue-particles";
import VueRouter from "vue-router";
import VueWindowSize from "vue-window-size";

//Mixins
import UserMixin from "./mixins/UserMixin";
import TermMixin from "./mixins/TermMixin";

// Custom Components
import nxsLoginView from "./components/Login.vue";
import nxsMaster from "./components/Master.vue";
import nxsDisputeModal from "./components/shared/Dispute.vue";

// VueRouter with components
import router from "./router";

// Vuex store components
import State from "./redux/state";
import getters from "./redux/getters";
import mutations from "./redux/mutations";
import Actions from "./redux/actions";

// Element UI
import "../css/theme/index.css";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";

// Moment used for time functions
import moment from "moment";

// Axios used for HTTP requests
import axios from "axios";

// Mixins
Vue.mixin(UserMixin);
Vue.mixin(TermMixin);

// Global Components
Vue.component("nxs-dispute-modal", nxsDisputeModal);

// Vue Use
Vue.use(Vuex);
Vue.use(VueWindowSize);
Vue.use(ElementUI, {locale});
Vue.use(VueRouter);
Vue.use(VueWindowSize);
Vue.use(VueParticles);
Vue.use(VueMq, {
    breakpoints: {
        xs: 768,
        sm: 992,
        md: 1200,
        lg: 1920,
        xl: Infinity
    }
});

/*eslint-disable */

// Axios
Vue.prototype.$csrfToken = Laravel.csrfToken;
axios.defaults.headers.common["X-CSRF-TOKEN"] = Laravel.csrfToken;
Vue.prototype.axios = axios;

// Element UI
var { Loading, MessageBox, Notification, Message } = ElementUI;
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
Vue.prototype.moment = moment;

// Create the Vuex store
const store = new Vuex.Store({
  state: State(Laravel.csrfToken),
  getters: getters,
  mutations: mutations,
  actions: Actions(axios)
});

// Create the Vue app
const app = new Vue({
  el: "#app",
  components: {
    nxsLoginView,
    nxsMaster
  },
  router,
  store
});

///
// Sets dev tools to only be used when not in production
///
if (process.env.MIX_NODE_ENV === "production") {
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
} else {
  Vue.config.devtools = true;
  Vue.config.debug = true;
  Vue.config.silent = false;
}
/*eslint-enable */
